import React, { useState } from "react";
import { Controller, FieldError } from "react-hook-form";
import { TextField, IconButton, InputAdornment, TextFieldProps, Grid, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { gridSize } from "@/shared";

type CustomEmailEditTextFielProps = {
  label: string
  onEditChange?: (editable: boolean) => void
  error: FieldError | undefined | boolean
  helperText: React.ReactNode
  disabled?: boolean
  shrink?: boolean
  required?: boolean
  readonly?: boolean

  type?: React.HTMLInputTypeAttribute
  size?: {
    xs: number
    sm: number
    md: number
    lg: number
  }
  register?: TextFieldProps

  control?: any
  name: string
  defaultValue?: string | number | null
  onChangeValue?: (value: any, valid?: boolean) => void

  sizeTextField?: "medium" | "small"
  startAdornment?: React.ReactNode



}

const CustomEmailEditTextFiel = ({
  label,
  //error,
  //helperText,
  //required = true,
  disabled = false,
  //shrink = false,
  size = gridSize,
  //type = "text",
  control,
  name,
  //defaultValue,
  //onChangeValue,
  sizeTextField = "medium",

  //startAdornment,
  onEditChange

}: CustomEmailEditTextFielProps) => {
  const [isEditable, setIsEditable] = useState(disabled);

  const onEdit = () => {
    setIsEditable(!isEditable)
    if (onEditChange) onEditChange(!isEditable)
  }

  return (
    <Grid item {...size}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label={label}
            size={sizeTextField}
            fullWidth
            disabled={!isEditable}
            variant="outlined"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            InputLabelProps={{
              shrink: !!field.value
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {field.value && (
                    <Tooltip title="Editar">
                      <IconButton onClick={onEdit}>
                        <EditIcon />
                      </IconButton>

                    </Tooltip>
                  )}


                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );
};
export default CustomEmailEditTextFiel
